export default __webpack_public_path__ + "static/media/rewards-bg.e7329b7b.jpg";